import { c as _c } from "react/compiler-runtime";
import useCartAndToken from 'hooks/useCartAndToken';
const useBagCount = () => {
  const $ = _c(2);
  const {
    cart
  } = useCartAndToken();
  let t0;
  if ($[0] !== cart) {
    t0 = cart && cart.length ? cart.reduce(_temp, 0) : 0;
    $[0] = cart;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const bagCount = t0;
  return bagCount;
};
export default useBagCount;
function _temp(acc, t0) {
  const {
    quantity: t1
  } = t0;
  const quantity = t1 === undefined ? 0 : t1;
  return acc + quantity;
}